// utils/parseContent.js
import React from "react";
import MailtoButton from "../components/PresentationModal/MailtoButton";

export const parseContentWithComponents = (componentsConfig) => {
  if (!componentsConfig) return null;

  const index = 0;
  if (componentsConfig?.mailtoButton) {
    return (
      <MailtoButton
        key={`mailto-${index}`}
        to={componentsConfig.mailtoButton.to}
        subject={componentsConfig.mailtoButton.subject}
        body={componentsConfig.mailtoButton.body}
        className="inline-mailto-button"
      >
        {componentsConfig.mailtoButton.text || "Nous contacter"}
      </MailtoButton>
    );
  }else{
    return(<></>)
  }
};
